import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import ZoneList from "../../components/Zone";

const ZonePage = (): ReactElement => {
  return (
    <Layout>
      <ZoneList />
    </Layout>
  );
};

export default ZonePage;
